// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import authReducer from "./authSlice";
import commonReducer from "./commonSlice/common";
import employeeReducer from "@slices/employeeSlice/employee";
import appConfigReducer from "@slices/configSlice/config";
import bankAccountsReducer from "@slices/bankAccountSlice/bankAccount";
import paymentMethodReducer from "@slices/paymentMethodSlice/paymentMethod";
import bankReducer from "@slices/bankSlice/bank";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import { enableMapSet } from "immer";

enableMapSet();

export const store = configureStore({
  reducer: {
    auth: authReducer,
    appConfig: appConfigReducer,
    common: commonReducer,
    employee:employeeReducer,
    bankAccounts: bankAccountsReducer,
    banks:bankReducer,
    paymentMethods: paymentMethodReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: undefined,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
